export const SET_NOTIFICATIONS_SETTINGS = 'SET_NOTIFICATIONS_SETTINGS'
export const CLEAR_SETTINGS = 'CLEAR_SETTINGS'
export const SET_SETTINGS_MODAL = 'SET_SETTINGS_MODAL'
